/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Vue.component('create-ticket', require('./components/CreateTicketComponent.vue'));
Vue.component('site-select', require('./components/SiteSelect.vue'));


// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
  el: '#app'
});

/**
 *
 */
window.Dropzone = require('dropzone');

Dropzone.options.formWithDropzone = {
  paramName: 'files',
  url: $('#js-ticket-form').attr('action'),
  autoProcessQueue: false,
  uploadMultiple: true,
  parallelUploads: 10,
  maxFiles: 10,
  maxFilesize: 5,
  acceptedFiles: 'image/*,application/pdf',
  addRemoveLinks: true,


  init: function () {

    var theDropzone = this;
    var theForm = $('#js-ticket-form');

    // // Update selector to match your button
    $("#js-submit-ticket-button").click(function (e) {
      e.preventDefault();

      $(this)
        .addClass('btn-disabled')
        .prop('disabled', true)
        .text('Odota...');

      if (theDropzone.getQueuedFiles().length > 0) {
        theDropzone.processQueue();
      } else {
        theForm.submit();
      }
    });

    this.on('sending', function (file, xhr, formData) {
      $('input, textarea').removeClass('is-invalid');
      $('.invalid-feedback').remove();

      var data = theForm.serializeArray();
      $.each(data, function (key, el) {
        formData.append(el.name, el.value);
      });
    });

    this.on('success', function (file, responseText) {
      window.location.href = responseText.url;
    });

    this.on('error', function (file, responseText) {
      $.each(theDropzone.files, function(i, file) {
        file.status = Dropzone.QUEUED
      });

      for (const [key, value] of Object.entries(responseText.errors)) {

        var input = $("[name=" + key + "]");

        input.addClass('is-invalid')
          .after('<span class="invalid-feedback" role="alert">' +
            '<strong>' + value[0] + '</strong>' +
            '</span>');
      }

      $("#js-submit-ticket-button")
        .removeClass('btn-disabled')
        .prop('disabled', false)
        .text('Lähetä');
    });

    this.on('complete', function (file, responseText) {

    });
  }
};



// WEBPACK FOOTER //
// ./resources/js/tickets/tickets.js